"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var _TroubleshootActions = require("MeetingsLib/redux/actions/TroubleshootActions");

var _handleActions;

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, ActionTypes.TOGGLE_TROUBLESHOOT_MODE, function (state, action) {
  return Object.assign({}, state, {
    active: action.active
  });
}), (0, _defineProperty2.default)(_handleActions, _TroubleshootActions.troubleshootActionTypes.RECEIVE_TROUBLESHOOT_TIMES, function (state, action) {
  return Object.assign({}, state, {
    data: action.data
  });
}), _handleActions), {
  active: false,
  data: undefined
});

exports.default = _default;
module.exports = exports.default;